module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "preface",
    attrs: {
      "id": "ing"
    }
  }, [_c('em', [_vm._v("Ingredients")])]), _vm._v(" "), _c('p', {
    staticClass: "centering"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/9781449400217_xiii-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Our readers seem so appreciative of the fact that most of the ingredients listed in our books are fairly easy to find. We live in a resort area that is really just a group of small towns surrounding a big lake. So I completely understand how difficult it might be if you live in a remote area to find what you need to prepare a recipe.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Below are brief descriptions of some of the basic ingredients used throughout this book.")])]), _vm._v(" "), _c('p', {
    staticClass: "hangingg"
  }, [_c('em', [_vm._v("Butter: It might be helpful for you, as you begin using "), _c('span', {
    staticClass: "underline"
  }, [_vm._v("At Our Table")]), _vm._v(", to know that I don’t mention in any of my recipes whether to use unsalted or salted butter. Most cookbooks suggest using unsalted butter, permitting the cook to have more control over the salt content of the recipe. This is particularly helpful when you are preparing food for someone on a low-salt diet. But to be honest, I always use salted butter. I just prefer the taste, and I’ve never pushed myself to make a change in the way I cook. So keep that in mind as you prepare these recipes.")])]), _vm._v(" "), _c('p', {
    staticClass: "hangingg"
  }, [_c('em', [_vm._v("Eggs: Use large eggs for the best results. I have variously used low-cholesterol eggs or regular eggs in my recipes, and I have not noticed any difference at all in the flavor or texture of the final prepared dishes.")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/9781449400217_xiv-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "hangingg"
  }, [_c('em', [_vm._v("Flour: I use mostly white bleached all-purpose flour in the recipes in this book. However, it is certainly permissible to substitute unbleached all-purpose flour. I would suggest using bread flour when called for, if possible.")])]), _vm._v(" "), _c('p', {
    staticClass: "hangingg"
  }, [_c('em', [_vm._v("Chocolate: Most of my recipes call for semisweet chocolate. I would suggest using the real thing — not a “flavored” semisweet chocolate. Remember that the higher the chocolate content, the lower the sugar content. Chocolate chips that are between 60 and 70 percent chocolate are best for these recipes.")])]), _vm._v(" "), _c('p', {
    staticClass: "hangingg"
  }, [_c('em', [_vm._v("Vanilla: I always use pure vanilla extract in my recipes. There just really isn’t any substitute! If you bake frequently, as I do, you may want to purchase a larger bottle of vanilla at a restaurant supply store or online, where it seems to be more affordable than those tiny bottles you find at the grocery store.")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/9781449400217_xiv-2.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a603630","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9781449400217_epub_ing_r1.vue
// module id = 81
// module chunks = 0